import React from 'react';
import { LayoutContext, type LayoutContextValue } from './LayoutContext';

export function useLayout(): LayoutContextValue {
  const context = React.useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}
